
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

// Returns the cart in JSON
Shopify.getCart = function(callback, ...params) {
  window.fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
  })
  .then((response) => response.json())
  .then((cart) => callback(cart, ...params))
  .catch((error) => {
      throw new Error(error);
  });
}

var updateFreePromoMessage = (function() {

  const promoNotification = document.getElementById('promoNotification');
  const promoNotificationShipping = document.getElementById('promoNotificationShipping');
  if(document.querySelector('[data-fs-threshold]')) {
    var freeShippingThreshold = parseFloat(document.querySelector('[data-fs-threshold]').getAttribute('data-fs-threshold'));
  }
  /*
  const promoNotificationGift = document.getElementById('promoNotificationGift');
  if(document.querySelector('[data-fg-threshold]')) {
    var freeGiftThreshold = parseFloat(document.querySelector('[data-fg-threshold]').getAttribute('data-fg-threshold'));
    // var freeGiftVariantId = parseFloat(document.querySelector('[data-fg-threshold]').getAttribute('data-gift-id'));
  }
  */

  var onCartUpdateDisplay = function (cart, containerTextEl, messageType) {
    let cartTotalPrice = cart.total_price;

    if(messageType == 'shipping') {
      let isFreeShipping = (cartTotalPrice >= freeShippingThreshold) ? true : false;

      setNotificationStatus(isFreeShipping, 'free-shipping', 'earned-free-shipping');

      if(sessionStorage.getItem('earned-free-shipping') == null) {
        promoNotificationShipping.classList.remove('hidden');
        containerTextEl.innerHTML = getShippingMessage(cartTotalPrice);
    }
      else {
        promoNotificationShipping.classList.add('hidden');
      }
    }

    promoNotification.classList.add('active');
    setTimeout(() => {
      promoNotification.classList.remove('active');
    }, 3000);

    return false;
  };

  var getShippingMessage = function(totalPrice) {
    if(totalPrice >= freeShippingThreshold) {
      return 'You have unlocked <span>FREE SHIPPING</span>';

    }
    else {
      let amountDifference =  (freeShippingThreshold - parseFloat(totalPrice)) / 100.00;
      return 'You are <span class="amount"> £'+ (parseFloat(amountDifference).toFixed(2)) +'</span> away from <span>FREE SHIPPING</span>';
    }
  };

  /**
   * To store the state of free shipping notification when threshold is met.
   * If true, do not display the notification again.
   *
   */
  var setNotificationStatus = function(conditionMet, initKey, key) {
    if(conditionMet) {
      if (sessionStorage.getItem(initKey) && sessionStorage.getItem(key) == null) {
        sessionStorage.setItem(key, true);
      }
      if(sessionStorage.getItem(initKey) == null) {
        sessionStorage.setItem(initKey,true);
      }
    }
    else {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(initKey);
        sessionStorage.removeItem(key);
      }
    }
  };

  var displayNotification = function(containerTextEl, messageType){
    // check latest content of cart and and display
    Shopify.getCart(onCartUpdateDisplay, containerTextEl, messageType);
  };

  return {
    updateFreePromoMessage : updateFreePromoMessage,
    getShippingMessage: getShippingMessage,
    displayNotification: displayNotification
  }

})();
